export enum PaymentRequestPaymentTypeEnum {
    Cash,
    BankAccount,
    Any
}